import React from 'react';
import PropTypes from 'prop-types';
import { MountedProvider } from '@luigiclaudio/ga-baseline-ui/helpers';
import { ModalProvider } from '@luigiclaudio/ga-baseline-ui/modal';
import { HeaderProvider } from '@luigiclaudio/ga-baseline-ui/header';
import LibrarySaveReturn from './LibrarySaveReturn';
import ToolAnalytics from './ToolAnalytics';
import RegistrationNewsletterSync from './newsletter/RegistrationNewsletterSync';
import SiteSeo from './SiteSeo';
import SiteIntlProvider from './SiteIntlProvider';
import ColorToolsProvider from './context/ColorToolsProvider';
import SiteHeader from './pageLayout/SiteHeader';
import theme from '../styles/theme';
import AdsGlobalStyles from './adsContainers/AdsGlobalStyles';
import FeedbackProvider from './feedbackContext/FeedbackProvider';
import SsrThemeProvider from './SsrThemeProvider';

const Layout = ({ currLocation, currTitle, children, pagePath, seo }) => {
    return (
        <SiteIntlProvider>
            <SiteSeo pathname={currLocation?.pathname || '/'} pagePath={pagePath} seo={seo} />
            <MountedProvider>
                <HeaderProvider>
                    <ColorToolsProvider>
                        <ToolAnalytics />
                        <RegistrationNewsletterSync />
                        <SsrThemeProvider theme={theme}>
                            <AdsGlobalStyles />
                            <FeedbackProvider>
                                <ModalProvider>
                                    <LibrarySaveReturn />
                                    <SiteHeader
                                        logoPath="/media/site-logo-dark.svg?render=img"
                                        logoPathAlt="/media/site-logo-light.svg?render=img"
                                        title={currTitle}
                                        logoWidth={156}
                                        currentPath={currLocation?.pathname}
                                    >
                                        {children}
                                    </SiteHeader>
                                </ModalProvider>
                            </FeedbackProvider>
                        </SsrThemeProvider>
                    </ColorToolsProvider>
                </HeaderProvider>
            </MountedProvider>
        </SiteIntlProvider>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    currLocation: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    currTitle: PropTypes.string,
    pagePath: PropTypes.string,
    seo: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        canonicalPath: PropTypes.string,
        robots: PropTypes.string,
    }),
};

Layout.defaultProps = {
    currLocation: undefined,
    currTitle: undefined,
    pagePath: undefined,
    seo: undefined,
};

export default Layout;
